import { Pipe, PipeTransform } from '@angular/core';
import { ColumnData } from './basic-table.component';
import { TableColumnsType, TableNames } from '../../../../shared/enums/common';

@Pipe({
  name: 'basicTable',
  standalone: true,
})
export class BasicTablePipe implements PipeTransform {
  transform(data: { [key: string]: any }[], tableName?: string) {
    if (data.length > 0) {
      let columns: ColumnData[] = Object.entries(data[0]).map(([key, value]) => {
        let type;
        let buttonLabel: string = '';
        let hasTag = false;
        let tag = '';
        let displayName = '';

        if (key == TableColumnsType.icon) type = 'icon';
        if (key == TableColumnsType.studentInstructions) {
          type = 'button';
          buttonLabel = 'View Instructions';
          displayName = 'Instructions';
        }
        if (key == TableColumnsType.contacts || key == TableColumnsType.equipment || key == TableColumnsType.instructions) type = 'array';
        if ((tableName == TableNames.passengers && key == TableColumnsType.contacts)) {          
          type = 'button';
          buttonLabel = 'View Contacts';
          displayName = 'Contacts';
        }

        if ((tableName == TableNames.students || tableName == TableNames.passengers) && key == TableColumnsType.name) {
          hasTag = true;
          tag = 'Student';
        }

        if (key == TableColumnsType.contacts) displayName = 'Contact(s)';
        if (key == TableColumnsType.notes) displayName = 'Note(s)';
        if (key == TableColumnsType.instructions) displayName = 'Instructions';

        return {
          name: key,
          displayName,
          type,
          hasTag,
          tag,
          buttonLabel,
        };
      });
      return {
        columns,
        data,
      };
    } else {
      return {
        columns: [],
        data: [],
      };
    }
  }
}
